module.exports = __webpack_public_path__ + "img/news.dbbea253.png";